import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  key: 0,
  class: "context-menu-icon"
};
const _hoisted_3 = {
  class: "context-menu-label"
};
const _hoisted_4 = {
  key: 1,
  class: "context-menu-shortcut"
};
const _hoisted_5 = {
  key: 2,
  class: "context-menu-arrow"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "context-menu-icon"
};
const _hoisted_8 = {
  class: "context-menu-label"
};
const _hoisted_9 = {
  key: 1,
  class: "context-menu-shortcut"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [_createVNode(_Transition, {
    name: "context-menu"
  }, {
    default: _withCtx(() => [$props.visible ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      ref: "menuRef",
      class: "context-menu",
      style: _normalizeStyle($setup.menuStyle),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onContextmenu: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedItems, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: item.key || index,
        class: _normalizeClass(["context-menu-item", {
          'context-menu-item--disabled': item.disabled,
          'context-menu-item--danger': item.danger,
          'context-menu-item--divider': item.type === 'divider'
        }]),
        onClick: $event => $setup.handleClick(item)
      }, [item.icon ? (_openBlock(), _createElementBlock("span", _hoisted_2, [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1), item.shortcut ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.shortcut), 1)) : _createCommentVNode("", true), item.children ? (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5l7 7-7 7"
      })], -1)]))])) : _createCommentVNode("", true)], 10, _hoisted_1);
    }), 128)), $setup.activeSubmenu !== null && $setup.sortedItems[$setup.activeSubmenu]?.children ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "context-menu context-menu--sub",
      style: _normalizeStyle($setup.getSubmenuStyle($setup.sortedItems[$setup.activeSubmenu]))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedItems[$setup.activeSubmenu].children, (child, childIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: child.key || childIndex,
        class: _normalizeClass(["context-menu-item", {
          'context-menu-item--disabled': child.disabled,
          'context-menu-item--danger': child.danger
        }]),
        onClick: $event => $setup.handleClick(child)
      }, [child.icon ? (_openBlock(), _createElementBlock("span", _hoisted_7, [(_openBlock(), _createBlock(_resolveDynamicComponent(child.icon)))])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_8, _toDisplayString(child.label), 1), child.shortcut ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(child.shortcut), 1)) : _createCommentVNode("", true)], 10, _hoisted_6);
    }), 128))], 4)) : _createCommentVNode("", true)], 36)) : _createCommentVNode("", true)]),
    _: 1
  }), $props.visible ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "context-menu-backdrop",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.close && $setup.close(...args))
  })) : _createCommentVNode("", true)]);
}